import {
  useRef,
  useState,
  useEffect,
  type ReactElement,
  cloneElement,
} from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

interface AutoTooltipProps extends Omit<TooltipProps, 'children'> {
  children: ReactElement;
}

export const AutoTooltip = ({ children, ...props }: AutoTooltipProps) => {
  const elementRef = useRef<HTMLElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      const el = elementRef.current;
      if (el) {
        setIsTruncated(el.scrollWidth > el.clientWidth);
      }
    };

    checkTruncation();

    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [children.props.children]);

  const clonedChild = cloneElement(children, {
    ref: elementRef,
    style: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      ...children.props.style,
    },
  });

  return (
    <Tooltip
      {...props}
      disableHoverListener={!isTruncated}
      disableTouchListener={!isTruncated}
      disableInteractive
    >
      {clonedChild}
    </Tooltip>
  );
};
